import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface DeleteFollowUpResponse {
  carePlan: fhirTypes.CarePlan;
}

export const useDeleteFollowUp = ({
  childEncounterId,
  carePlanId,
}: {
  childEncounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<DeleteFollowUpResponse, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.UPDATE({
          patientId,
          childEncounterId,
          carePlanId,
        }),
      mutationFn: () => {
        return axiosInstance.delete(
          `/charting/careplan/${carePlanId}/followup`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.FollowUp.DEFAULT({
              patientId,
              childEncounterId,
              carePlanId,
            }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId: childEncounterId,
          }),
        });
      },
    },
  });
};
